import React, { useState } from 'react';
import styled from '@emotion/styled';
import { CirclePlus } from '../../../../shared/Icon/components/CirclePlus';
import { CircleMinus } from '../../../../shared/Icon/components/CircleMinus';
import Text from '../../../../shared/Text';

type FAQProps = {
  answer: JSX.Element;
  question: string;
};

function FAQ({ answer, question }: FAQProps) {
  const [isHidden, setIsHidden] = useState(true);

  const onClickToggle = () => {
    setIsHidden(!isHidden);
  };

  return (
    <Wrapper>
      <Toggle
        aria-label={`${
          isHidden ? 'show' : 'hide'
        } answer for the question "${question}"`}
        onClick={onClickToggle}
      >
        {isHidden ? <CirclePlus /> : <CircleMinus />}
      </Toggle>
      <div>
        <div style={{ marginBottom: 25 }}>
          <Text
            size="xl"
            sizeAtSmScreen="md"
            align="left"
            color="#000000"
            isBold={true}
          >
            {question}
          </Text>
        </div>
        {!isHidden && <div>{answer}</div>}
      </div>
    </Wrapper>
  );
}

export { FAQ };

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 25px;
`;

const Toggle = styled.button`
  margin-right: 35px;
  &:focus {
    svg path {
      fill: #8940fa;
    }
  }
`;
